import type { BagAllowance } from '@optionway/models';

// Joins only the sides the airline actually sent: a partial allowance (a missing depth is common)
// would otherwise render as "40x30xcm".
export const formatDimensions = (bag?: Pick<BagAllowance, 'height' | 'width' | 'depth'>): string | undefined => {
  const sides = [bag?.height, bag?.width, bag?.depth].filter((side) => Number.isFinite(side));
  return sides.length > 0 ? `${sides.join('x')}cm` : undefined;
};
